import {inject} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    RouterStateSnapshot, UrlTree
} from '@angular/router';
import {AuthGuardData, createAuthGuard} from 'keycloak-angular';
import {ROLE} from '../enums/role';
import {KeycloakWrapperService} from '../keycloak/keycloak-wrapper.service';
import {UK_URL_PATTERN} from '../keycloak/defaults';

export const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const {authenticated, grantedRoles} = authData;
    const _kcService = inject(KeycloakWrapperService);
    if (!authenticated) {
        await _kcService.login({
            redirectUri: window.location.origin + state.url,
            locale: (() => window.location.origin.includes(UK_URL_PATTERN) ? 'en' : 'de')()
        }).catch(e => console.error(e));
    }
    const minRequiredRole: string = route.data['role'];

    const hasRequiredRole = (role: string): boolean =>
        Object.values(grantedRoles.resourceRoles).some((roles) => !role ? true :
            role === ROLE.ADMIN ? roles.includes(role) : roles.includes(ROLE.ADMIN) || roles.includes(role));

    return hasRequiredRole(minRequiredRole);
};
export const authGuard: CanActivateFn = createAuthGuard<CanActivateFn>(isAccessAllowed);
